import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import FolderIcon from "components/lib/Shared/Icons/Folder";
import LadderIcon from "components/lib/Shared/Icons/Ladder";
import PointerIcon from "components/lib/Shared/Icons/Pointer";
import SidebarItem from "./SidebarItem";
import { Roles_Permissions_Constants } from "config/roles-permissions";
import { Constants } from "config/constants";

function Sidebar({ selectedTab, setSelectedTab, isForHistory }) {
  const history = useHistory();
  const { dashboardRoles, dashboardPermissions, designation } = useSelector(
    (state) => state.companyDashboardSlice
  );
  const viewRestrictedData = dashboardPermissions.some(
    (permission) =>
      permission.name ===
      Roles_Permissions_Constants.DASHBOARD_PERMISSIONS.VIEW_RESTRICTED_DATA
  );
  const auditTabs = [
    {
      id: "accountSettings",
      label: "Account Settings",
      disabled:
        !dashboardRoles.some(
          (role) =>
            role.name === Roles_Permissions_Constants.DASHBOARD_ROLES.REGISTRAR
        ) &&
        !dashboardPermissions.some(
          (permission) =>
            permission.name ===
            Roles_Permissions_Constants.DASHBOARD_PERMISSIONS.MANAGE_USERS
        ),
    },
    { id: "notifications", label: "Notifications", disabled: true },
    { id: "transactions", label: "Transactions" },
    { id: "auditTrail", label: "Audit Trail", disabled: true },
  ];
  const documentPermissionValues = Object.values(
    Roles_Permissions_Constants.DOCUMENT_PERMISSIONS
  );
  const hasDocumentPermissions = dashboardPermissions.some((docPermission) =>
    documentPermissionValues.includes(docPermission.name)
  );
  const generalTabs = useMemo(() => {
    const baseTabs = [{ id: "businessDetails", label: "Business Details" }];
    if (
      ![Constants.APPLICANT_CAPACITIES.AUTHORIZED_PERSON].includes(
        designation
      ) ||
      viewRestrictedData ||
      hasDocumentPermissions
    ) {
      baseTabs.push({
        id: "minuteBook",
        label: "Minute Book",
      });
    }
    return baseTabs;
  }, [viewRestrictedData, designation, documentPermissionValues]);

  const managementTabs = useMemo(
    () => [
      {
        id: "compliance",
        label: "Compliance Tracker",
        disabled: true,
        comingSoon: true,
      },
      {
        id: "companies",
        label: "Companies",
        disabled: !dashboardRoles?.some(
          (role) =>
            role.name === Roles_Permissions_Constants.DASHBOARD_ROLES.REGISTRAR
        ),
      },
      {
        id: "manageYourCompany",
        label: "Manage your company",
      },
      {
        id: "contracts",
        label: "Contracts",
        disabled: true,
        comingSoon: true,
      },
      {
        id: "history",
        label: "History",
      },
    ],
    [dashboardRoles]
  );

  const handleTabClick = (item) => {
    if (item?.disabled) return null;
    if (item?.href) return history.push(item.href);
    else setSelectedTab(item);
  };

  return (
    <div className="col-span-4 md:col-span-1 pt-8">
      <div>
        <h4 className="mb-2 text-sflPrimary font-medium flex items-center">
          <FolderIcon className="w-5 h-5" aria-hidden="true" />
          <span className="pl-2">General</span>
        </h4>
        <ul className="ml-10">
          {generalTabs.map((item) => (
            <SidebarItem
              key={item.label}
              item={item}
              selectedTab={selectedTab}
              handleTabClick={handleTabClick}
            />
          ))}
        </ul>
      </div>
      <div className="border-t pt-2">
        <h4 className="mb-2 text-sflPrimary font-medium flex items-center">
          <LadderIcon className="w-5 h-5" aria-hidden="true" />
          <span className="pl-2">Management</span>
        </h4>
        <ul className="ml-10">
          {managementTabs.map((item) => (
            <SidebarItem
              key={item.label}
              item={item}
              selectedTab={selectedTab}
              handleTabClick={handleTabClick}
              isForHistory={isForHistory}
            />
          ))}
        </ul>
      </div>
      <div className="border-t pt-2">
        <h4 className="mb-2 text-sflPrimary font-medium flex items-center">
          <PointerIcon className="w-5 h-5" aria-hidden="true" />
          <span className="pl-2">Audit</span>
        </h4>
        <ul className="ml-10">
          {auditTabs.map((item) => (
            <SidebarItem
              key={item.label}
              item={item}
              selectedTab={selectedTab}
              handleTabClick={handleTabClick}
            />
          ))}
        </ul>
      </div>
    </div>
  );
}

export default Sidebar;
